import request from "@/plugins/axios";

/** S 模型 **/
export const apiModelList = (params: any) =>
  request.get("/model.modelList/lists", { params });

export const apiModelAdd = (data: any) =>
  request.post("/model.modelList/add", data);

export const apiModelEdit = (data: any) =>
  request.post("/model.modelList/edit", data);

export const apiModelDetail = (params: any) =>
  request.get("/model.modelList/detail", { params });

export const apiModelDelete = (data: any) =>
  request.post("/model.modelList/del", data);

export const apiModelStatus = (data: any) =>
  request.post("/model.modelList/status", data);

export const apiModelShare = (data: any) =>
  request.post("/model.modelList/share", data);

export const apiModelShareList = (params: any) =>
  request.get("/model.modelList/listsSid", { params });

export const apiModelFastEdit = (data: any) =>
  request.post("/model.modelList/fastEdit", data);

export const apiModelCopy = (params: any) =>
  request.get("/model.modelList/copy", { params });
/** E 模型 **/

/** S 分类 **/
export const apiModelCategoryList = (params: any) =>
  request.get("/model.modelCategory/lists", { params });

export const apiModelCategoryAdd = (data: any) =>
  request.post("/model.modelCategory/add", data);

export const apiModelCategoryEdit = (data: any) =>
  request.post("/model.modelCategory/edit", data);

export const apiModelCategoryDetail = (params: any) =>
  request.get("/model.modelCategory/detail", { params });

export const apiModelCategoryDelete = (data: any) =>
  request.post("/model.modelCategory/del", data);
/** E 分类 **/

/** S 材质 **/
export const apiModelMaterialList = (params: any) =>
  request.get("/model.modelMaterial/lists", { params });

export const apiModelMaterialAdd = (data: any) =>
  request.post("/model.modelMaterial/add", data);

export const apiModelMaterialEdit = (data: any) =>
  request.post("/model.modelMaterial/edit", data);

export const apiModelMaterialDetail = (params: any) =>
  request.get("/model.modelMaterial/detail", { params });

export const apiModelMaterialDelete = (data: any) =>
  request.post("/model.modelMaterial/del", data);

/** E 材质 **/

/** S 颜色 **/
export const apiColorList = (params: any) =>
  request.get("/model.modelColor/lists", { params });

export const apiColorAdd = (data: any) =>
  request.post("/model.modelColor/add", data);

export const apiColorEdit = (data: any) =>
  request.post("/model.modelColor/edit", data);

export const apiColorDetail = (params: any) =>
  request.get("/model.modelColor/detail", { params });

export const apiColorDelete = (data: any) =>
  request.post("/model.modelColor/del", data);

/** E 颜色 **/

/** S 定制部位 */
export const apiModelDesignPartsLists = (params: any) =>
  request.get("/model.modelDesignParts/lists", { params });

export const apiModelDesignPartsAdd = (data: any) =>
  request.post("/model.modelDesignParts/add", data);

export const apiModelDesignPartsEdit = (data: any) =>
  request.post("/model.modelDesignParts/edit", data);

export const apiModelDesignPartsDelete = (data: any) =>
  request.post("/model.modelDesignParts/del", data);

export const apiModelDesignFastEdit = (data: any) =>
  request.post("/model.modelDesignParts/fastEdit ", data);
/** E 定制部位 */

/** S 效果图 */
export const apiModelEffectLists = (params: any) =>
  request.get("/model.modelDesignEffect/lists", { params });

export const apiModelEffectAdd = (data: any) =>
  request.post("/model.modelDesignEffect/add", data);

export const apiModelEffectEdit = (data: any) =>
  request.post("/model.modelDesignEffect/edit", data);

export const apiModelEffectDelete = (data: any) =>
  request.post("/model.modelDesignEffect/del", data);

export const apiModelEffectFastEdit = (data: any) =>
  request.post("/model.modelDesignEffect/fastEdit", data);
/** E 效果图 */

export const apiModelGetConfig = (params: any) =>
  request.get("/model.modelList/getConfig", { params });
export const apiModelSetConfig = (data: any) =>
  request.post("/model.modelList/setConfig", data);

//建模申请列表
export const apiModelModelApplyLists = (params: any) =>
  request.get("/model.ModelApply/lists", { params });

//建模申请列表详情
export const apiModelModelApplyDetail = (params: any) =>
  request.get("/model.ModelApply/detail", { params });

//建模申请状态
export const apiModelModelApplyGetStatus = (params: any) =>
  request.get("/model.ModelApply/getStatus", { params });

//建模申请日志
export const apiModelModelApplyGetLogList = (params: any) =>
  request.get("/model.ModelApply/getLogList", { params });

//建模申请添加日志
export const apiModelModelApplyAddLog = (data: any) =>
  request.post("/model.ModelApply/addLog", data);

// 建模模板
// 模板状态
export const apiModelModelApplyExampleGetStatus = (params: any) =>
  request.get("/model.ModelApplyExample/getStatus", { params });
// 模板列表
export const apiModelModelApplyExampleLists = (params: any) =>
  request.get("/model.ModelApplyExample/lists", { params });
// 模板详情
export const apiModelModelApplyExampleDetail = (params: any) =>
  request.get("/model.ModelApplyExample/detail", { params });
// 模板详情
export const apiModelModelApplyExampleDel = (data: any) =>
  request.post("/model.ModelApplyExample/del", data);
// 新增模板
export const apiModelModelApplyExampleAdd = (data: any) =>
  request.post("/model.ModelApplyExample/add", data);
// 编辑模板
export const apiModelModelApplyExampleEdit = (data: any) =>
  request.post("/model.ModelApplyExample/edit", data);
// 分配设计师
export const apiModelModelApplyDesigner = (data: any) =>
  request.post("/model.ModelApply/designer", data);

/** 模型标签 */
export const apiModelModelTagLists = (params: any) =>
  request.get("/model.modelTag/lists", { params });

/** 模型标签添加 */
export const apiModelModelTagAdd = (data: any) =>
  request.post("/model.modelTag/add", data);

/** 模型标签编辑 */
export const apiModelModelTagEdit = (data: any) =>
  request.post("/model.modelTag/edit", data);

/** 模型标签删除 */
export const apiModelModelTagDelete = (data: any) =>
  request.post("/model.modelTag/del", data);

/** 模型标签分类列表 */
export const apiModelModelTagCategoryLists = (params: any) =>
  request.get("/model.modelTagCategory/lists", { params });

/** 模型标签分类添加 */
export const apiModelModelTagCategoryAdd = (data: any) =>
  request.post("/model.modelTagCategory/add", data);

/** 模型标签分类编辑 */
export const apiModelModelTagCategoryEdit = (data: any) =>
  request.post("/model.modelTagCategory/edit", data);

/** 模型标签分类删除 */
export const apiModelModelTagCategoryDelete = (data: any) =>
  request.post("/model.modelTagCategory/del", data);

/** 上架模型市场 */
export const apiModelSetMarketStatus = (data: any) =>
  request.post("/model.modelList/setMarketStatus", data);

//同步详情
export const apiModelSyncContent = (data: any) =>
  request.post("/model.modelList/syncContent", data);


// 供应链市场模型
export const apiSupplyModelLists = (params: any) =>
  request.get("/model.modelSupply/lists", { params });

export const apiSupplyModelSetCommission = (post: any) =>
  request.post("/model.modelSupply/setSupplyCommission", post);


export const apiSupplyModelSetPrice = (post: any) =>
  request.post("/model.modelSupply/setSupplyPrice", post);

export const apiSupplyModelGetBuyShopList = (params: any) =>
  request.get("/model.modelList/getBuyShopList", { params });


export const apiGetSupplyCommissionLog = (params: any) => request.get('model.modelSupply/getSupplyCommissionLog', { params })